import * as React from 'react';

import { Row as AntRow } from 'antd';
import {
  Icon,
  LeftOutlined,
  LoadingOutlined,
  Modal,
  RetweetOutlined,
  Row,
  Space,
} from 'farmhub-ui-core';
import { useSelector } from 'react-redux';

import { RootState } from 'app';

import { CButtonBack, CButton, SpaceStyles } from './styles';

interface AccountModalProps {
  height?: number;
  listStep: any[];
  visible: boolean;
  isToggle: boolean;
  entityType: string;
  currentStep: number;
  isSelecting: boolean;
  entityNumberType: number;
  handleChangeVisible: (e: boolean) => void;
  handleChangeEntityType: (e: string) => void;
  handleChangeCurrentStep: (e: number) => void;
  renderEntityIcon: (e: number) => React.ReactNode;
  renderEntityName: (e: string) => React.ReactNode;
}

const AccountModalMobile = ({
  isToggle,
  entityNumberType,
  height = 42,
  listStep,
  entityType,
  visible,
  isSelecting,
  currentStep,
  renderEntityIcon,
  renderEntityName,
  handleChangeVisible,
  handleChangeEntityType,
  handleChangeCurrentStep,
}: AccountModalProps) => {
  const entity = useSelector((state: RootState) => state.account.item);

  return (
    <>
      <CButton height={height} onClick={() => handleChangeVisible(true)}>
        <Row justifyContent="space-between" styles={SpaceStyles}>
          <Row justifyContent={isToggle ? 'flex-start' : 'center'}>
            <Icon>{renderEntityIcon(entityNumberType)}</Icon>
            {isToggle && (
              <>
                <Space width={12} />
                <div className="text">{entity?.displayName}</div>
              </>
            )}
          </Row>

          {isToggle &&
            (isSelecting ? (
              <LoadingOutlined spin style={{ fontSize: 16 }} />
            ) : (
              <RetweetOutlined className="icon" style={{ fontSize: 16 }} />
            ))}
        </Row>
      </CButton>

      <Modal
        centered
        bodyHeight={currentStep !== 0 ? '630px' : '700px'}
        footer={null}
        title={
          currentStep !== 0 ? (
            <Row justifyContent="center">
              <Space height={28} />
              <CButtonBack
                onClick={() => {
                  handleChangeCurrentStep(currentStep - 1);
                  handleChangeEntityType('farm');
                }}
              >
                <LeftOutlined className="icon" />
              </CButtonBack>
              {currentStep === 2 && renderEntityName(entityType)}
            </Row>
          ) : null
        }
        visible={visible}
        width={
          currentStep === 0
            ? '600px'
            : (entityType === 'transport' && currentStep !== 1) ||
              (entityType === 'warehouse' && currentStep !== 1) ||
              (entityType === 'volunteer' && currentStep !== 1)
            ? 'auto'
            : '1000px'
        }
        onCancel={() => handleChangeVisible(false)}
        onOk={() => handleChangeVisible(false)}
      >
        {' '}
        <AntRow justify="center" style={{ height: '100%' }}>
          {listStep[currentStep]}
        </AntRow>
      </Modal>
    </>
  );
};

export default AccountModalMobile;
